module.exports = __webpack_public_path__ + "img/unchecked-circle.300285b3.svg";